module.exports = __webpack_public_path__ + "628679df36de9c9c41237e1785ca3ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/S@2x.png
// module id = 844
// module chunks = 0